import { withFeatureFlags } from '@atlassian/mpac-feature-flags';
import React from 'react';
import { resolveDiscoverHeadingText } from '../utils/headings';
import TextSearchWrapper from './common/TextSearch/TextSearchWrapper';
const HeroWrapper = props => {
  const Hero = props.heroComponent;
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(TextSearchWrapper, {
    filters: props.filters,
    searchComponent: Hero,
    extraProps: {
      discoverHeading: resolveDiscoverHeadingText({
        filters: props.filters,
        featureFlags: {}
      }),
      filters: props.filters
    },
    perspective: props.perspective,
    stateChangeRequested: props.stateChangeRequested
  }));
};
export default withFeatureFlags(HeroWrapper);